import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import IframeWeb from './IframeWeb'


const Support = () => {
    const [message, setMessage] = useState('');
    const navigate = useNavigate()

    function launchChat(){
        navigate('/chat')
    }
    return (
        // <div className='wrapper' style={{ marginTop: '6.5rem' }}>
        //     <IframeWeb height="750" source="https://trampolinehealth.circle.so/home" />
        // </div>
        <div className='wrapper' style={{ marginTop: '6.5rem', marginLeft: '1.5rem', marginRight:' 1.5rem' }}>
            <div>
                <h2 className="text-center"> We're in this Together <br/> You're not Alone</h2>
            </div>
            <div className="container" style={{ marginTop: '3rem'}}>
                <div className="item" style={{ padding: '0' }}>
                    <h5> Mental Wellness Support </h5>
                    {/* <a href="https://trampolinehealth.circle.so/home">Community Support Forum</a>
                    <br></br>
                    <br></br>
                    <a href="https://usemotion.com/meet/fernando-bohorquez-ynb/bk4nn1n?d=30">Schedule a one on one</a>
                    <br></br>
                    <br></br> */}
                    <div className="homeBttnContainer" style={{ display:'flex', flexDirection:'column', marginTop:"2.5rem" }}>
                        <button className="homeBttn" onClick={() => {window.open("https://trampolinehealth.circle.so/join?invitation_token=3cff0ae5ec294f740a32bac3219619a5e2e27ed9-a1faea1f-4698-44e9-be22-47c01f9a128d", "_blank");}}  >Community Support</button>
                        <button className="homeBttn" style={{ marginTop:'1rem'}} onClick={() => {window.open("https://usemotion.com/meet/fernando-bohorquez-ynb/bk4nn1n?d=30", "_blank");}}>Schedule One on One</button>
                        <button className="homeBttn" style={{ marginTop:'1rem'}} onClick={() => {navigate('/in-development')}}>Mental Health Hotlines</button>

                    </div>

                    {/* <h5> Group Sessions </h5>
                    Next meeting:  <a href="">How to have difficult conversations @ 04/20/23: 7pm ET</a>
                    <br></br>
                    <br></br> */}
                    <h5> Technical Support </h5>
                    {/* <a href="https://forms.gle/DVWGTTjrHSwCga7F7">Bug Report Form</a>
                    <br></br>
                    <br></br>
                    <a href="mailto:fernando@trampolinehealth.co?subject=Beta%20Support">Support Email</a>
                    <br></br>
                    <br></br> */}
                    <div className="homeBttnContainer" style={{ display:'flex', flexDirection:'column', marginTop:"2.5rem" }}>
                        <button className="homeBttn" onClick={() => {navigate('/settings')}}>Settings</button>
                        <button className="homeBttn"  style={{ marginTop:'1rem'}} onClick={() => {window.open("https://forms.gle/DVWGTTjrHSwCga7F7", "_blank");}}  >Bug Report Form</button>
                        <button className="homeBttn" style={{ marginTop:'1rem'}} onClick={() => {window.open("mailto:fernando@trampolinehealth.co?subject=App%20Support", "_blank");}}>Support Email</button>
                    </div>

                        {/* <div className="form-group"><label> Send a message: </label><br /> <input type="text" placeholder='question you have' value={message} onChange={event => setMessage(event.target.value)} /> <br /></div>
                        <div className="form-group"><input class="submit-bttn" type="submit" value="Submit" /><br /></div> */}
                </div>
            </div>
        </div>
)
}


export default Support;